import Menu from './Menu.js';
import MenuItem from './MenuItem.js';
import SubMenu from './SubMenu/index.js';
import MenuItemGroup from './MenuItemGroup.js';
import 'react';
import Divider from './Divider.js';
var ExportMenu = Menu;
ExportMenu.Item = MenuItem;
ExportMenu.SubMenu = SubMenu;
ExportMenu.ItemGroup = MenuItemGroup;
ExportMenu.Divider = Divider;
export { Divider, MenuItem as Item, MenuItemGroup as ItemGroup, MenuItem, MenuItemGroup, SubMenu, ExportMenu as default };
//# sourceMappingURL=index.js.map
